<template>
  <v-container fluid class="pa-0 ma-0">
    <v-row justify="end" class="mb-2">
      <v-col cols="auto">
        <ButtonCustomIcon
          icon="cloud_download"
          color="primary"
          text="Excel"
          :disabled="!data || data.length === 0"
          @click="handleExportToExcel"
        />
      </v-col>
    </v-row>
    <v-data-table
      dense
      :headers="headers"
      :items="data"
    >
      <template v-slot:item.billRate="{ item }">
        {{ item.billRate | currency }}
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { ButtonCustomIcon } from '@/components/buttons'
import { formatCurrency } from '@/lib/display'
import excel from '@/lib/export/excel'

export default {
  components: {
    ButtonCustomIcon
  },
  props: [
    'data'
  ],
  data () {
    return {
      headers: [
        { text: 'Consultant', value: 'fullName', width: '70%' },
        { text: 'Hourly Bill Rate', value: 'billRate', align: 'center', width: '30%' }
      ]
    }
  },
  methods: {
    handleExportToExcel () {
      if (!this.data || this.data.length === 0) {
        return
      }

      const data = this.data.map(item => ({
        fullName: item.fullName,
        billRate: formatCurrency(item.billRate)
      }))
      excel.exportArray2Excel({
        title: ['Consultant', 'Hourly Bill Rate'],
        key: ['fullName', 'billRate'],
        data,
        autoWidthFlag: true,
        filename: 'Headcount'
      })
    }
  }
}
</script>
